import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'

import './RescheduleRecurrenceConfirm.scss'
import ProfileMobileNavBar from 'components/ProfileMobileNavBar'
import RecurrenceDetails from './components/RecurrenceDetails'
import ModifyingServiceLoader from 'components/ModifyingServiceLoader'
import RecurrenceModificationPenalty from 'components/RecurrenceModificationPenalty'
import * as qs from 'utils/querystring'
import * as paths from 'utils/paths'

class RescheduleRecurrenceConfirm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      penaltyFetched: false
    }

    this.handlePenaltyFetched = this.handlePenaltyFetched.bind(this)
    this.updateRecurrence = this.updateRecurrence.bind(this)
  }

  componentDidMount () {
    this.fetchRecurrence()
  }

  fetchRecurrence () {
    const {
      params: { recurrenceId },
      fetchRecurrence
    } = this.props

    fetchRecurrence(recurrenceId)
  }

  handlePenaltyFetched () {
    this.setState({
      penaltyFetched: true
    })
  }

  updateRecurrence () {
    const {
      recurrence,
      updateRecurrence,
      location: {
        search: querystring
      }
    } = this.props

    const queryobject = qs.parse(querystring)

    const changes = {
      aliadaId: queryobject.aliadaId,
      estimatedHours: queryobject.estimatedHours,
      datetime: queryobject.datetime
    }

    updateRecurrence(recurrence.id, changes, () => {
      const { push, params } = this.props

      const path = paths.userNextServices(params.userId)
      push(path)
    })
  }

  isLoading () {
    const { recurrence } = this.props
    return !recurrence
  }

  render () {
    if (this.isLoading()) {
      const Loader = () => <div />
      return <Loader />
    }

    const {
      recurrence,
      beforeRescheduleRecurrenceDetails,
      afterRescheduleRecurrenceDetails,
      updatingRecurrence,
      location: {
        search: querystring
      },
      params: {
        userId,
        recurrenceId
      }
    } = this.props

    const queryobject = qs.parse(querystring)

    const recurrenceModifications = {
      estimatedHours: queryobject.estimatedHours,
      datetime: queryobject.datetime
    }

    const { penaltyFetched } = this.state

    const updateButtonIsEnabled = penaltyFetched

    return (
      <div className='RescheduleRecurrenceConfirm navbar-screen'>
        <ProfileMobileNavBar back>
          Confirmar cambios
        </ProfileMobileNavBar>

        <ModifyingServiceLoader
          isOpen={updatingRecurrence}
          text='Reagendando tu recurrencia...'
          />


        <div className='navbar-screen-content'>
          <div className='RescheduleRecurrenceConfirm-contentCard'>
            <div className='RescheduleRecurrenceConfirm-cardTitle'>
              Confirmar Cambios
            </div>

            <div className='RescheduleRecurrenceConfirm-cardBody'>
              <p>
                Se realizarán los siguientes cambios.
              </p>

              <div className='RescheduleRecurrenceConfirm-before'>
                <p>
                  Antes
                </p>

                <RecurrenceDetails details={beforeRescheduleRecurrenceDetails} />
              </div>

              <div className='RescheduleRecurrenceConfirm-after'>
                <p>
                  Ahora
                </p>

                <RecurrenceDetails details={afterRescheduleRecurrenceDetails} />
              </div>

              <RecurrenceModificationPenalty
                recurrenceId={recurrence.id}
                recurrenceModifications={recurrenceModifications}
                onPenaltyFetched={this.handlePenaltyFetched}
                />

              <p>
                ¿Estás seguro de que quieres realizar estos cambios?
              </p>
            </div>

            <div className='RescheduleRecurrenceConfirm-buttons'>
              <Link
                className='RescheduleRecurrenceConfirm-cancelBtn btn btn-default btn-lg btn-block'
                to={paths.userModifyRecurrence(userId, recurrenceId)}
                >
                Cancelar cambios
              </Link>

              <button
                className='RescheduleRecurrenceConfirm-confirmBtn btn btn-primary btn-lg btn-block'
                onClick={this.updateRecurrence}
                disabled={!updateButtonIsEnabled}
                >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

RescheduleRecurrenceConfirm.displayName = 'RescheduleRecurrenceConfirm'
RescheduleRecurrenceConfirm.propTypes = {
  recurrence: PropTypes.object.isRequired,
  recurrenceModifications: PropTypes.object.isRequired,
  afterRescheduleRecurrenceDetails: PropTypes.object.isRequired,
  updatingRecurrence: PropTypes.object.isRequired
}
RescheduleRecurrenceConfirm.defaultProps = {}

export default RescheduleRecurrenceConfirm



// WEBPACK FOOTER //
// ./src/screens/App/screens/Recurrences/screens/RescheduleRecurrenceConfirm/RescheduleRecurrenceConfirm.js